export const signUp_style = {
  imgSx: {
    width: '100%',
    height: '100%',
    pt: 2,
    pb: 4,
    borderRadius: '0%',
  },

  imgContSx: {
    maxWidth: '90%',
    mx: 'auto',
    my: 'auto',
  },

  lastText: {
    color: 'text.secondary',
    fontSize: 14,
    opacity: 1,
    textAlign: 'center',
    mt: 1,
    display: 'flex',
    gap: 0.5,
    justifyContent: 'center',
  },

  buttonsStyle: {
    textTransform: 'none',
    height: '40px',
    mt: 1,
    mb: 4,
  },

  signSx: {
    fontWeight: 600,
    fontSize: '14px',
    color: 'primary.main',
    opacity: 1,
    cursor: 'pointer',
    textDecoration: 'none',
  },

  paperSx: {
    borderRadius: '24px 24px 0px 0px',
    px: 2.5,
    pt: 5,
    pb: 4,
    bgcolor: 'common.white',
  },

  eyeSx: {
    width: '20px',
    height: '20px',
  },

  googleStyle: {
    color: '#ACACAC',
    border: '1px solid',
    borderColor: 'grey.400',
    textTransform: 'none',
  },

  titleSx: {
    color: 'text.primary',
    fontSize: '20px',
    fontWeight: 600,
  },
  subTitleSx: {
    color: 'text.hint',
    fontSize: '14px',
  },
};
